import React from 'react';
import styles from './AuthImage.module.css';

import StartImage from '@images/start.jpg';

const AuthImage = () => {
  return (
    <img className={styles.wrapper} src={StartImage} />
  )
}

export default AuthImage;
